import React from "react";

const STYLES = {
  good: { label: "Good", bg: "bg-[#E6F4EA]", text: "text-[#0C6B2E]", border: "border-[#A3E0B5]", dot: "bg-[#0C6B2E]" },
  moderate: { label: "Moderate", bg: "bg-[#FEF3C7]", text: "text-[#92400E]", border: "border-[#FDE68A]", dot: "bg-[#B45309]" },
  weak: { label: "Weak", bg: "bg-[#FCE8E8]", text: "text-[#C92A2A]", border: "border-[#FECACA]", dot: "bg-[#C92A2A]" },
};

export function AIVisibilityBadge({ level, testid }) {
  if (!level) {
    return (
      <span
        data-testid={testid || "ai-visibility-empty"}
        className="text-xs text-muted-foreground"
      >
        —
      </span>
    );
  }
  const s = STYLES[level] || STYLES.weak;
  return (
    <span
      data-testid={testid || `ai-visibility-${level}`}
      className={`inline-flex items-center gap-1.5 rounded-full border ${s.bg} ${s.text} ${s.border} px-2.5 py-0.5 text-xs font-medium`}
      title="AI Visibility (composite of rating × reviews × recent activity)"
    >
      <span className={`inline-block h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}

export function AIPositionPill({ text, testid }) {
  if (!text) {
    return (
      <span
        data-testid={testid || "ai-position-empty"}
        className="text-xs text-muted-foreground"
      >
        —
      </span>
    );
  }
  return (
    <span
      data-testid={testid || "ai-position-pill"}
      className="inline-flex items-center gap-1 rounded-md border border-electric/30 bg-electric-soft px-2 py-0.5 text-[11px] font-medium text-electric"
      title="Position in AI Mode / Local Pack for this niche+area"
    >
      ✦ {text}
    </span>
  );
}
